import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'
import { createIcon } from '../create-icon'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgBell = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.17466 1.33426C9.17466 1.87158 8.81363 2.32457 8.32093 2.4639C10.8223 2.62903 12.8 4.71022 12.8 7.25334V10.9333C12.8 11.7934 12.8351 12.4879 13.5718 12.8563C13.7931 12.9669 13.9092 13.2152 13.8524 13.4559C13.7955 13.6967 13.5807 13.8667 13.3333 13.8667H8.70554C8.92698 14.0621 9.06664 14.3481 9.06664 14.6667C9.06664 15.2558 8.58908 15.7333 7.99997 15.7333C7.41087 15.7333 6.9333 15.2558 6.9333 14.6667C6.9333 14.3481 7.07297 14.0621 7.29441 13.8667H2.66666C2.41931 13.8667 2.20442 13.6967 2.14759 13.4559C2.09077 13.2152 2.2069 12.9669 2.42814 12.8563C3.16489 12.4879 3.19999 11.7934 3.19999 10.9333V7.25334C3.19999 4.70974 5.17847 2.62824 7.68045 2.4638C7.18792 2.32436 6.82705 1.87146 6.82705 1.33426C6.82705 0.68599 7.35258 0.160461 8.00086 0.160461C8.64912 0.160461 9.17466 0.68599 9.17466 1.33426ZM7.99999 3.52C5.93813 3.52 4.26666 5.19147 4.26666 7.25334V10.9333L4.26669 10.9876C4.2672 11.4627 4.26796 12.169 3.94591 12.8H12.0541C11.7321 12.169 11.7328 11.4627 11.7333 10.9876V10.9333V7.25334C11.7333 5.19147 10.0619 3.52 7.99999 3.52Z"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgBell)
const IconSvgBell = createIcon(ForwardRef, 'SvgBell')
export default IconSvgBell
